import React, { MouseEvent } from "react";
import { Button, Icon } from "@vp/swan";
import { useTranslation } from "../../useTranslation";
import "./BackButton.scss";

import { Screens } from "../ScreensLayout";

interface BackLinkProps {
  onChangeScreen: (screen: Screens) => void;
}

export const BackLinkControl: React.FunctionComponent<BackLinkProps> = (
  props: BackLinkProps
) => {
  const [t] = useTranslation("app");
  const { onChangeScreen } = props;

  const handleOnClick = (e: MouseEvent): void => {
    e.preventDefault();

    onChangeScreen(Screens.SignIn);
  };

  return (
    <>
    <Button
      data-testid="back"
      id="back-reset"
      skin="secondary"
      width="full-width"
      onClick={handleOnClick}
      iconPosition="left"
      aria-label={t("backToSignIn")}
    >
      <Icon iconType="arrowLeft" />
      {t("backToSignIn") }
    </Button>
    </>
  );
};

const BackLink: React.FunctionComponent<BackLinkProps> = React.memo(
  BackLinkControl
);
export default BackLink;
